<template>
    <div class="record-print" id="pdfDom">
        <div class="page">
            <div class="header">
                <div class="cover_title">
                    <!-- <img class="logo" src="../assets/img/record_print/logo.svg">
                    <img src="../assets/img/record_print/title.svg" width="500px"> -->
                </div>
            </div>
            <div class="main" style="margin-top: 70px;">
                <div class="left_section">
                    <div class="qrcode">
                        <img :src="qrcodeUrl" width="120px">
                    </div>
                </div>
                <div class="right_section">
                    <div class="title_info">
                        <div>
                            <p class="title font-small pl-3">檔案名稱：</p>
                            <p class="pl-4">{{this.printData.fileName}}</p>
                        </div>
                        <div>
                            <p class="title font-small pl-3">證書編號：</p>
                            <p class="pl-4">{{this.printData.fileId}}</p>
                        </div>
                    </div>
                    <div class="info_box">
                        <div class="info_box-result">
                            <div class="table_header bg-darkblue">驗證資訊</div>
                            <div class="table_body">
                                <div class="file_info">
                                    <table>
                                        <tr>
                                            <th>證據編號：</th>
                                            <td v-if="this.printData.verify">{{this.printData.verify.id}}</td>
                                            <th>存證時間：</th>
                                            <td v-if="this.printData.verify">{{this.printData.verify.time}}</td>
                                        </tr>
                                        <tr>
                                            <th>檔案雜湊值：</th>
                                            <td colspan="3" v-if="this.printData.verify">
                                                {{this.printData.verify.hash}}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="info_box-result">
                            <div class="table_header bg-gold">存證資訊</div>
                            <div class="table_body">
                                <div class="file_info">
                                    <table>
                                        <tr>
                                            <th>機關單位</th>
                                            <td v-if="this.printData.record">{{this.printData.record.unit}}</td>
                                            <th>存證人員：</th>
                                            <td v-if="this.printData.record">{{this.printData.record.person}}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="info_box-blockchain">
                            <div class="table_header bg-gold">區塊鏈資訊</div>
                            <div class="table_body">
                                <div class="file_info">
                                    <table>
                                        <tr>
                                            <th>Chaincode 名稱：</th>
                                            <td v-if="this.printData.chain">{{this.printData.chain.name}}</td>
                                        </tr>
                                        <tr>
                                            <th>Transaction ID：</th>
                                            <td v-if="this.printData.chain">{{this.printData.chain.transaction}}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sign_content">
                        <div class="sign_item">
                            <p>司法聯盟鏈</p>
                            <hr>
                            <p class="title font-small">證書認證單位</p>
                        </div>
                        <div class="sign_item">
                            <p>{{this.printData.certifyTime}}</p>
                            <hr>
                            <p class="title font-small">證書列印日期</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import QRCode from 'qrcode'
// import MobileDetect from 'mobile-detect'
// import { htmlToPdf } from '../utils/functions.js'

export default {
    name: "RecordPrint",
    data() {
        return {
            printData: {},
            qrcodeUrl: ''
        }
    },
    async mounted() {
        if(process.env.VUE_APP_WEBSITE_AVAILABLE == 0){
            this.$router.push('/');
        }
        // let md = new MobileDetect(navigator.userAgent);
        const proveId = this.$route.query.id;
        // let pdfFilename = 'export';
        const fetchData = async () => {
            try {
                const res = await axios.get(`${process.env.VUE_APP_BACKEND_API_URL}/byProveId?id=${proveId}`);
                // pdfFilename = 'bj-' + res.data.proveId;
                this.printData = {
                    fileName: res.data.filename,
                    fileId: 'bj-' + res.data.proveId,
                    verify: {
                        id: res.data.GUID,
                        time: moment.unix(Math.floor(parseInt(res.data.timestamp) / 1000)).format('YYYY/MM/DD HH:mm:ss'),
                        hash: res.data.filehash
                    },
                    record: {
                        unit: res.data.user.user_company,
                        person: res.data.user.user_name
                    },
                    chain: {
                        name: 'mojchain-test',
                        transaction: res.data.txid,
                    },
                    certifyTime: moment.unix(Math.floor(Date.now() / 1000)).format('YYYY/MM/DD HH:mm:ss')
                }
                this.qrcodeUrl = await QRCode.toDataURL('https://b-jade.chainsecurity.asia/prove?id=' + proveId);
            } catch (err) {
                console.log(err)
            }
        }
        await fetchData();
        // if (!md.mobile()) {
        //     htmlToPdf.getPdf(pdfFilename);
        // }
    }
};
</script>
<style src="../assets/style/recordPrint.css" scoped></style>